import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DateFilter from "../../../components/common/DateFilter";

function SettlementHeader({
  setStartDate,
  setEndDate,
  startDate,
  endDate,
  getRollingReserveSettlements,
}) {
  const token = useSelector((store) => store.userReducer.token);
  let normalDate;

  const handleDateChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
    getRollingReserveSettlements(token, start, end);
  };

  return (
    <>
      <div className="header-settle">
        <h2 className="area-top-management">Rolling Reserve Settlements</h2>
      </div>
      <DateFilter onDateChange={handleDateChange} />
    </>
  );
}

export default SettlementHeader;
